import { Grid } from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
import {
  AutocompleteInput,
  Button,
  DateInput,
  FormDataConsumer,
  ReferenceInput,
  TimeInput,
  required,
  useNotify,
  useRecordContext,
} from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import { doctoralRequests } from "api/doctoralApi";
import { administrationRequests } from "api/administrationApi";

const pad = n => String(n).padStart(2, "0");

const toDateString = v => {
  if (!v) return null;
  if (typeof v === "string") return v.slice(0, 10);
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? null : `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

const toTimeString = v => {
  if (!v) return null;
  if (typeof v === "string") {
    const iso = v.match(/T(\d{2}:\d{2})/);
    if (iso) return iso[1];
    if (/^\d{2}:\d{2}/.test(v)) return v.slice(0, 5);
  }
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? null : `${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

const ScheduleDefenseDialog = ({ defense, onSaved }) => {
  const record = useRecordContext();
  const notify = useNotify();

  if (!record?.id) return null;

  const defaultValues = {
    defenseDate: defense?.defenseDate ? toDateString(defense.defenseDate) : null,
    defenseTime: defense?.defenseDate ? toTimeString(defense.defenseDate) : null,
    buildingId: defense?.buildingId ?? null,
    roomId: defense?.roomId ?? null,
  };

  const handleConfirm = async data => {
    const payload = {
      defenseDate: toDateString(data.defenseDate),
      defenseTime: toTimeString(data.defenseTime),
      buildingId: data.buildingId,
      roomId: data.roomId,
    };
    await dataProvider.customRequest(doctoralRequests.scheduleDoctorantDefense(record.id), payload, "PUT");
    notify("Защитата е насрочена успешно", { type: "success" });
    onSaved?.();
  };

  return (
    <FormModal
      titleContent="Насрочване на защита"
      saveTitle="Запази"
      dialogSize="md"
      defaultValues={defaultValues}
      onConfirm={handleConfirm}
      triggerButton={
        <Button
          label="Насрочи защита"
          variant="contained"
          startIcon={<EventIcon />}
        />
      }
    >
      <Grid
        container
        spacing={2}
        sx={{ mt: 0 }}
      >
        <Grid
          item
          xs={12}
          md={6}
        >
          <DateInput
            source="defenseDate"
            label="Дата на защита"
            validate={required("Задължително")}
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <TimeInput
            source="defenseTime"
            label="Час на защита"
            validate={required("Задължително")}
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <ReferenceInput
            source="buildingId"
            reference={administrationRequests.getBuildingsSelect()}
          >
            <AutocompleteInput
              label="Сграда"
              optionText="name"
              optionValue="id"
              validate={required("Задължително")}
              filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
              fullWidth
            />
          </ReferenceInput>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <FormDataConsumer>
            {({ formData }) =>
              formData?.buildingId ? (
                <ReferenceInput
                  source="roomId"
                  reference={administrationRequests.getRoomsSelect()}
                  filter={{ buildingId: formData.buildingId }}
                >
                  <AutocompleteInput
                    label="Зала"
                    optionText="roomName"
                    optionValue="id"
                    validate={required("Задължително")}
                    filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
                    fullWidth
                  />
                </ReferenceInput>
              ) : null
            }
          </FormDataConsumer>
        </Grid>
      </Grid>
    </FormModal>
  );
};

export default ScheduleDefenseDialog;
